import { Box, Button, Stack, Typography, alpha, useTheme } from "@mui/material"
import {
  StrikeThroughChip,
  formatNumber,
  formatPrice,
} from "@pharmupp/p3-front-commons"
import { Check } from "react-feather"

export const HeadSectionTitle = ({ children }: { children: string }) => (
  <Typography fontWeight={600} color="common.darkBlue">
    {children}
  </Typography>
)

export const PointsChip = ({
  nbLoyaltyPoints,
  isMissed,
}: { nbLoyaltyPoints: number; isMissed: boolean }) => {
  const { typography, palette } = useTheme()
  const typo = typography.pxToRem(14)
  const color = isMissed ? palette.common.cloudGray : palette.common.electricBlue

  return (
    <StrikeThroughChip
      color={color}
      isStrikethrough={isMissed}
      underlineGap={typo}
      label={`${formatNumber(nbLoyaltyPoints)} pts`}
      haveUnderline={!isMissed}
    />
  )
}

export const PriceChip = ({ children }: { children: number }) => {
  const theme = useTheme()
  const color = theme.palette.primary.main
  return (
    <Button
      variant="outlined"
      sx={{
        borderColor: color,
        pointerEvents: "none",
      }}
    >
      <Stack
        direction="row"
        spacing={0.5}
        pb={0.5}
        alignItems="center"
        borderBottom={`1px solid ${color}`}
        fontWeight={600}
        lineHeight={theme.typography.pxToRem(16)}
      >
        <Typography
          fontSize={theme.typography.pxToRem(16)}
          lineHeight={theme.typography.pxToRem(16)}
          fontWeight="600"
          color={theme.palette.success.main}
        >
          +
        </Typography>
        {formatPrice(children)}
      </Stack>
    </Button>
  )
}

export const RegisterStatusChip = ({
  nbLoyaltyPoints,
  isValidated,
}: { nbLoyaltyPoints: number; isValidated: boolean }) => {
  const { palette, typography, spacing } = useTheme()
  const typo = typography.pxToRem(14)
  const color = palette.success.main
  const label = isValidated ? `${formatNumber(nbLoyaltyPoints)} pts` : "Inscrit"

  return (
    <StrikeThroughChip
      color={color}
      label={label}
      sx={{ fontWeight: "600" }}
      haveUnderline={isValidated}
      icon={
        <Box
          sx={{
            position: "relative",
            pr: spacing(1),
            mr: "0px!important",
            "&::after": {
              content: '""',
              position: "absolute",
              right: 0,
              height: typo,
              width: "1px",
              bgcolor: alpha(color, 0.3),
              top: "50%",
              transform: "translateY(-50%)",
            },
          }}
        >
          <Check color={color} size={typo} />
        </Box>
      }
    />
  )
}
